import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { motion } from "motion/react";

export default function AnchorLinks({
  LINKS,
  handleClick,
  setShowNavigation,
  linkRefs,
  activeLink,
}) {
  const { t } = useTranslation("translation", { keyPrefix: "navigation" });

  return window.location.pathname === "/" ? (
    LINKS.map((link, index) => (
      <li
        key={index}
        ref={(link) => (linkRefs.current[index] = link)}
        onClick={() => handleClick(index)}
      >
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }}>
          <a
            className={`header-navbar__link ${activeLink === index ? "active" : ""}`}
            onClick={() => setShowNavigation(false)}
            href={`#${link.name}`}
          >
            {t(link.name)}
          </a>
        </motion.div>
      </li>
    ))
  ) : (
    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }}>
      <NavLink to={"/"} className="header-navbar__link">
        {t("main")}
      </NavLink>
    </motion.div>
  );
}
